export default "__VITE_ASSET__C5Hgora6__"